import { Box, CircularProgress, FormControlLabel, RadioGroup, Switch, Typography } from "@mui/material";
import { IMarketplace } from "../../../../interfaces/IMarketplace";
import { RadioCard } from "../../../../../core/components/RadioCard";
import { TipoAgendamentoPedido, TipoAgendamentoPedidoDescricao, TipoAgendamentoPedidoTitulo } from "../../../../enum/TipoAgendamentoPedido";
import { useState } from "react";
import { useMarketplaces } from "../../../../hooks/useMarketplaces";

interface AgendamentoPedidoContainerProps {
    marketplace: IMarketplace;
    refresh: () => void;
}

export const AgendamentoPedidoContainer = ({ marketplace, refresh }: AgendamentoPedidoContainerProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const { salvar } = useMarketplaces();

    const tipoAtual = marketplace?.configuracao?.tipoAgendamentoPedido ?? TipoAgendamentoPedido.NENHUM;
    const obrigatorioAtual = marketplace?.configuracao?.agendamentoObrigatorio ?? false;

    const handleTipoAgendamento = async (tipo: TipoAgendamentoPedido) => {
        setLoading(true);
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                tipoAgendamentoPedido: tipo,
                agendamentoObrigatorio: tipo === TipoAgendamentoPedido.NENHUM ? false : obrigatorioAtual
            }
        });
        setTimeout(() => {
            refresh();
            setLoading(false);
        }, 1500);
    }

    const handleObrigatorio = async (obrigatorio: boolean) => {
        setLoading(true);
        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                agendamentoObrigatorio: obrigatorio
            }
        });
        setTimeout(() => {
            refresh();
            setLoading(false);
        }, 1500);
    }

    if (loading) {
        return (
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '5rem',
                marginBottom: '5rem',
            }}>
                <CircularProgress size={50} />
            </Box>
        );
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 2 }}>
            <RadioGroup
                name="tipo-agendamento-pedido"
                row
                sx={{ display: "flex", justifyContent: "flex-start", gap: '2rem', width: "100%" }}
                onChange={(e) => handleTipoAgendamento(e.target?.value as TipoAgendamentoPedido)}
            >
                {Object.values(TipoAgendamentoPedido).map((tipo) => (
                    <RadioCard
                        key={tipo}
                        labelTitle={TipoAgendamentoPedidoTitulo[tipo]}
                        labelDescription={TipoAgendamentoPedidoDescricao[tipo]}
                        labelValue={tipo}
                        selected={tipoAtual === tipo}
                        onClick={() => handleTipoAgendamento(tipo)}
                    />
                ))}
            </RadioGroup>

            {tipoAtual !== TipoAgendamentoPedido.NENHUM && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={obrigatorioAtual}
                                onChange={(e) => handleObrigatorio(e.target.checked)}
                            />
                        }
                        label={
                            <Typography variant="body2">
                                Preenchimento obrigatório
                            </Typography>
                        }
                    />
                </Box>
            )}
        </Box>
    );
}
